<script>
	import UIDate from "../ui/UIDate.svelte";
	import UITag from "../ui/UItag.svelte";
	import router from "../stores/router";
	import base from "../stores/base";

	export let data = {};
</script>

<li class="UIListItem">
	<a
		href={"/" + data.category + "/" + data.id}
		on:click|preventDefault={() =>
			router.push("/" + data.category + "/" + data.id)}
	>
		<figure
			class="UIListItem-cover"
			style="background-image:url({data.cover || $base.defaultCover})"
		>
			<img src="/img/dummy-2-1.png" alt="" />
		</figure>
		<div class="UIListItem-wrap">
			<div class="UIListItem-date">
				<UIDate list date={data.date} lang={$base.lang} />
			</div>
			<div class="UIListItem-title">
				{@html data.title.split("\n").join("<br>")}
			</div>
			<!-- <div class="UIListItem-description">
				{@html data.description.split("\n").join("<br>")}
			</div> -->
			<div class="UIListItem-category">
				<UITag># {$base.categories[data.category][$base.lang]}</UITag>
			</div>
			<div class="UIListItem-more">
				<span>{{ ja: "記事を読む", en: "Read Post" }[$base.lang]}</span
				>
			</div>
		</div>
	</a>
</li>

<style global>
	.UIListItem {
		width: 100%;
		padding: 1em 0.25em;
		text-align: left;
	}
	@media screen and (min-width: 480px) {
		.UIListItem {
			width: 50%;
			padding: 0.5em 0.25em;
		}
	}
	@media screen and (min-width: 960px) {
		.UIListItem {
			width: 33.3%;
			padding: 1em;
		}
	}

	.UIListItem > a {
		display: block;
		transition: border 100ms linear;
		/* padding: 0.5em; */
		border: 1px dashed transparent;
		height: 100%;
		background-color: #fff;
		transition: box-shadow 100ms linear;
	}
	:global(.pc) .UIListItem > a:hover {
		/* border-color: #bb5858; */
		box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
	}
	.UIListItem > a:focus-visible {
		border: 1px dashed #bb5858;
	}
	.UIListItem-cover {
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		background-color: #f6f6f6;
		margin-bottom: 0.5em;
		height: 224px;
	}
	.UIListItem-cover > img {
		width: 100%;
		height: 100%;
	}
	.UIListItem-wrap {
		padding: 0.5em 2em;
		height: 250px;
		position: relative;
	}
	.UIListItem-date {
		color: #888;
		font-size: 0.95em;
	}
	.UIListItem-title {
		padding: 0.25em 0;
		font-size: 1.2em;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		height: 74px;
	}
	.UIListItem-description {
		color: #888;
		padding: 0.25em 0;
		font-size: 0.9em;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	.UIListItem-category {
		padding: 1em 0 0;
	}
	.UIListItem-more {
		border-top: 1px solid #cccccc;
		margin-top: 1em;
		padding-top: 0.6em;
		text-align: right;
		color: #bb5858;
		font-size: 1.375em;
	}

	.UIListItem > a:hover .UIListItem-more {
		text-decoration: underline;
	}

	.UIListItem-more span {
		position: relative;
		padding-right: 20px;
	}
	.UIListItem-more span::after {
		content: "";
		width: 8px;
		height: 8px;
		border: 0;
		border-top: 2px solid #bb5858;
		border-right: 2px solid #bb5858;
		transform: rotate(45deg);
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		right: 0;
	}
</style>
